import { usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";

import { api } from "@/api";

/** Connects the global API client to Next navigation and resets its 401 guard after route transitions. */
export const useApiRouter = (): void => {
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    api.router = router;
    api.resetUnauthorizedErrorGuard();
  }, [pathname, router]);
};
